import store from '../store'

export default {
  getCurrentDateTime(){
    var date = new Date();
    var nowUTC =  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());

    return new Date(nowUTC);
  },

  getUnixCurrentDateTime(){
    return Math.floor(this.getCurrentDateTime().getTime() / 1000);
  },

  formatDateTime(dateTime) {
    let date = new Date(dateTime);
    let dateStr =  date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2) + ":" +
            ("00" + date.getSeconds()).slice(-2);

    return dateStr
  },

  removeTimeTZ(time){
    return time.toLocaleString().replace('T', ' ').replace('Z', ' ');
  },

  getLocalDateTime(){
    return new Date().toLocaleString("en-US",Intl.DateTimeFormat().resolvedOptions().timeZone);
  },

  getTokenRemainingTime(){
    if (!store.state.auth || !store.state.auth.jwtPayload){
      return 0;
    }

    const payload = store.state.auth.jwtPayload;
    if (payload.exp) {
      return Math.round(payload.exp * 1000 - Date.now());
    }

    let tokenExp = store.state.auth.tokenExpiry || payload.expires_at;
    if (tokenExp != null) {
      const expDate = new Date(tokenExp);
      if (!isNaN(expDate.getTime())) {
        return Math.round(expDate.getTime() - Date.now());
      }
    }

    return 0;
  },

  getTokenRemainingSeconds(){
    const remainingMs = this.getTokenRemainingTime();
    return remainingMs ? Math.floor(remainingMs / 1000) : 0;
  },

  convertDatetimeByTimezone(dateTime) {
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (dateTime == null){
        return "";
    }

    return new Date((typeof dateTime === "string" ? new Date(dateTime) : dateTime).toLocaleString("en-US", {timeZone: timezone}));
  },

  isValidDomain(v) {
    if (!v) return false;
    var re = /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/gi;
    return re.test(v);
  },

  isValidUrl(v) {
    if (!v || typeof v !== 'string') return false;
    const trimmed = v.trim();
    if (!trimmed) return false;

    // Must start with http:// or https:// and have a valid domain / host
    const urlPattern = /^https?:\/\/(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-_]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}|(?:\d{1,3}\.){3}\d{1,3}|localhost)(?::\d{1,5})?(?:[/?#]\S*)?$/i;
    if (!urlPattern.test(trimmed)) return false;

    try {
      const urlObj = new URL(trimmed);
      if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') return false;
      if (!urlObj.hostname) return false;
      if (urlObj.hostname.endsWith('.')) return false;
      const parts = urlObj.hostname.split('.');
      if (parts.some(part => part.startsWith('-') || part.endsWith('-') || part.startsWith('_') || part.endsWith('_'))) return false;
      return true;
    } catch {
      return false;
    }
  },

  parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  },

  getTokenParam(){
    var url = new URL(window.location);
    var email = url.searchParams.get("token");

    return email;
  },

  getRedirectURL(){
    var url = new URL(window.location);
    var redirectURL = url.searchParams.get("redirect_url");

    return redirectURL;
  },

  setOrganisationID() {
    const org = store.state.user.organisation || {};
    if (this.isVertexAnalyst()) {
      let analystOrg = null;
      try {
        const organisationString = localStorage.getItem('userOrganisation');
        analystOrg = organisationString ? JSON.parse(organisationString) : null;
      } catch (e) {
        analystOrg = null;
      }

      // Self-heal userOrganisation in localStorage if missing/null
      if (!analystOrg) {
        const orgRole = store.state.auth.jwtPayload?.organisation_role?.[0];
        if (orgRole) {
          const orgList = store.state.user?.organisations || [];
          const matched = orgList.find(o => o.id == orgRole.organisation_id);
          analystOrg = {
            id: matched?.id || orgRole.organisation_id,
            name: matched?.name || orgRole.organisation || 'Organisation'
          };
          try {
            localStorage.setItem('userOrganisation', JSON.stringify(analystOrg));
          } catch (e) {
            // Ignore quota or private-browsing errors
          }
        }
      }

      const isNotDashboard = typeof window !== 'undefined' && window.location && window.location.pathname !== '/dashboard';
      if (isNotDashboard) {
        const analystOrgId = analystOrg?.id || store.state.auth.jwtPayload?.organisation_role?.[0]?.organisation_id;
        if (analystOrgId) return analystOrgId;
      }
      const adminOrgId = org.id || org.organisation_id;
      return (adminOrgId && adminOrgId !== 'undefined' && adminOrgId !== 'null') ? adminOrgId : (analystOrg?.id || null);
    }
    if (store.state.auth.isSuperAdmin) {
      const adminOrgId = org.id || org.organisation_id;
      return (adminOrgId && adminOrgId !== 'undefined' && adminOrgId !== 'null') ? adminOrgId : null;
    }
    let orgId = org.organisation_id || org.id;
    if (!orgId || orgId === 'undefined' || orgId === 'null') {
      const roles = store.state.auth.jwtPayload?.organisation_role;
      if (Array.isArray(roles) && roles.length > 0) {
        const coreProducts = [
          'automated_test_phishing_campaigns',
          'cyber_security_online_awareness_training',
          'email_compromise_check',
          'policy_management',
        ];
        const matchedOrg = roles.find(
          (r) => Array.isArray(r.products) && r.products.some((p) => coreProducts.includes(p.product))
        ) || roles[0];
        orgId = matchedOrg?.organisation_id || matchedOrg?.id;
      }
    }
    return (orgId && orgId !== 'undefined' && orgId !== 'null') ? orgId : null;
  },

  checkUserRole(products, role){
    var isExist = false
    products.forEach(product => {
        if (product.roles.includes(role))
          isExist = true
    });

    return isExist
  },

  checkRole(products, product,role){
    var isExist = false
    products.forEach(v => {

      if (product == v.product) {
        if (v.roles.includes(role))
          isExist = true
      }
    });

    return isExist
  },

  limitString(str, len){
    if (str == null || str == "")
      return "";

    if (str.length > len)
      return str.substring(0, len) + '...';

    return str.substring(0, len);
  },

  isVertexAnalyst (){
    return store.state.auth.accessType == "vertex_analyst"
  },

  isUserAdmin() {
    if (!store.state.user.organisation?.products) return false;

    const rawProducts = store.state.user.organisation?.products;
    let products = this.isVertexAnalyst()
      ? (Array.isArray(rawProducts?.[0]) ? rawProducts[0] : (Array.isArray(rawProducts) ? rawProducts : (store.state.auth.jwtPayload?.organisation_role?.[0]?.products || [])))
      : (Array.isArray(rawProducts) ? rawProducts : []);

    for (const product of products) {
      if (product && product.roles && product.roles.includes("admin") == true) {
        return true;
      }
    }

    return false;
  },

  settingsAdmin() {
    if (!store.state.user.organisation?.products) return false;
    const rawProducts = store.state.user.organisation?.products;
    let products = this.isVertexAnalyst()
      ? (Array.isArray(rawProducts?.[0]) ? rawProducts[0] : (Array.isArray(rawProducts) ? rawProducts : (store.state.auth.jwtPayload?.organisation_role?.[0]?.products || [])))
      : (Array.isArray(rawProducts) ? rawProducts : []);

    for (const product of products) {
      if (product && ['email_compromise_check', 'cyber_security_online_awareness_training', 'training', 'automated_test_phishing_campaigns', 'phishing', 'pentester_platform', 'policy_management'].includes(product.product)) {
        if (product.roles && product.roles.includes("admin"))
          return true;
      }
    }
    return false;
  },

  trainingAdmin() {
    if (!store.state.user.organisation?.products) return false;

    if (store.state.user.organisation.is_organisation_admin && store.state.auth.hasTraining) return true;

    const rawProducts = store.state.user.organisation?.products;
    let products = this.isVertexAnalyst()
      ? (Array.isArray(rawProducts?.[0]) ? rawProducts[0] : (Array.isArray(rawProducts) ? rawProducts : (store.state.auth.jwtPayload?.organisation_role?.[0]?.products || [])))
      : (Array.isArray(rawProducts) ? rawProducts : []);

    for (const product of products) {
      if (product && (product.product === 'cyber_security_online_awareness_training' || product.product === 'training')) {
        if (product.roles && product.roles.includes("admin"))
          return true;
      }
    }

    return false;
  },

  truncateLongText(fullStr, strLenLimit, separator = "...") {
    if (fullStr.length <= strLenLimit) return fullStr;

    const sepLen = separator.length;
    const charsToShow = strLenLimit - sepLen;

    return fullStr.substr(0, charsToShow).trim() + separator;
  },

  getErrorMessage(error) {
    if (error.isAxiosError) {
      if (error.response) {
        // Check if the error response has a message
        return error.response.data.message || error.response.statusText || 'An error occurred';
      } else if (error.request) {
        // No response received
        return 'No response received from server';
      }
    }
    // Handle non-Axios errors
    return error.message || 'An unexpected error occurred';
  }
}